// Import external dependencies
import 'jquery';

// Import everything from autoload


// Import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import taxEstateNegotiation from './routes/taxEstateNegotiation';
import singleEstate from './routes/singleEstate';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,

  taxEstateNegotiation,

  singleEstate,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
